export default __webpack_public_path__ + "static/media/avax.e1fb45e8.png";